/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-24 19:43:32
 */
import { Button, Input, Modal, message } from "antd";
import SwitchDark from "@/components/SwitchDark";
import loginLeft from "@/assets/images/login_left.png";
import logo from "@/assets/images/logo.png";
import FindPassword from "@/assets/images/findPassword.png";
import { useNavigate } from "react-router-dom";
import { validateResetPasswordEmail } from "@/api/modules/register";
import "../index.less";
import { useState } from "react";
import { useSelector } from "react-redux";

const EmailValidate = () => {
	const navigate = useNavigate();
	const { language } = useSelector(state => state.global);
	const [email, setEmail] = useState();
	const [status, setStatus] = useState(0);
	const handleReset = () => {
		if (!email) {
			message.info("请输入邮箱");
			return;
		}
		try {
			validateResetPasswordEmail({ email: email, language: language }).then(res => {
				if (res.code === 200) {
					setStatus(1);
				}
			});
		} catch (e) {
			console.log(e);
		}
	};
	return (
		<div className="email-container">
			{status === 0 && (
				<div className="login-box">
					<div className="login-form">
						<div className="login-logo">
							<span className="resset_title">Password recovery</span>
						</div>

						<div>
							<p>
								<span>Email</span>
							</p>
							<Input
								style={{ borderRadius: 10, minWidth: 600, height: 40 }}
								onChange={({ target: { value } }) => {
									setEmail(value);
								}}
							/>
						</div>

						<div>
							<Button
								style={{ width: "100%", marginTop: 30, height: 44, fontSize: 20, borderRadius: 10, background: "#565BDD" }}
								type="primary"
								onClick={() => handleReset()}
							>
								Reset Password
							</Button>
						</div>
						<div style={{ marginTop: 40 }}>
							<p className="login-form-text">
								Back to
								<a onClick={() => navigate("/login")} style={{ color: "#565BDD", marginLeft: 10 }}>
									Log in
								</a>
							</p>
						</div>
					</div>
				</div>
			)}

			{status === 1 && (
				<div className="resultBox">
					<div style={{ textAlign: "center" }}>
						<img src={FindPassword} alt="" />
					</div>
					<div style={{ textAlign: "center" }}>
						<p>We've just sent password reset link to {email}.</p>
						<p> Please check your inbox and spam folders.</p>
					</div>
					<div>
						<Button
							onClick={() => {
								navigate("/");
							}}
							style={{ width: "100%", marginTop: 20, height: 40, backgroundColor: "#565BDD", color: "#fff" }}
						>
							Back to AdSurgebot
						</Button>
					</div>
				</div>
			)}
		</div>
	);
};

export default EmailValidate;
